import { Pipe, PipeTransform } from '@angular/core';
import { VisitationFamilyDetails } from 'src/models/vistationFamily';

@Pipe({
    name: 'visitationfilter',
    pure: false
})
export class VisitationFilterPipe implements PipeTransform {
    transform(items: VisitationFamilyDetails[], conditions: string): any {
        return conditions ? items.filter(item =>
            item.FamilyName?.toLowerCase()?.indexOf(conditions.toLowerCase()) > -1 ||
            item.EmergencyMobile?.indexOf(conditions) > -1 ||
            item.Comments?.indexOf(conditions) > -1 ||
            item.FullAddress?.toLowerCase()?.indexOf(conditions.toLowerCase()) > -1 ||
            item.FamilyNames?.toLowerCase()?.indexOf(conditions.toLowerCase()) > -1
        ) : items;
    }
}